import { Components } from '../../material';

export const MuiMenu: Components['MuiMenu'] = {
  defaultProps: {
    slotProps: {
      paper: {
        elevation: 6,
      },
    },
  },
  styleOverrides: {},
};
